<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center" style="gap:10px;">

      <div>
        <div class="section-title">{{ $tc("cashCards") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("manageAllyourCashCardshere") }}
        </div>
      </div>

          <div>
        <b-form-input
          v-debounce:300="onSearchCashCard"
          v-model="searchValue"
          placeholder="Search"
        ></b-form-input>
      </div>

      </div>

      <div class="d-flex align-items-center" style="gap:5px">
     
      
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.filter_is_active = filterIsActive;
              getCashCardList();
            }
          "
        />
        <b-dropdown
          :text="cardType"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(cardFilter, cf_index) in cardTypeArray"
            :key="cf_index"
            v-on:click="onChangeCardFilter(cardFilter)"
            >{{ cardFilter.name }}</b-dropdown-item
          >
        </b-dropdown>

         <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <b-button
          variant="default"
          :to="{ name: 'Add Cash Card' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>

        <div class="">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>


      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3"v-if="false">
      
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.filter_is_active = filterIsActive;
              getCashCardList();
            }
          "
        />
        <b-dropdown
          :text="cardType"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(cardFilter, cf_index) in cardTypeArray"
            :key="cf_index"
            v-on:click="onChangeCardFilter(cardFilter)"
            >{{ cardFilter.name }}</b-dropdown-item
          >
        </b-dropdown>
        <div class="">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="mx-auto row white-wrapper mb-3">
      <div class="col-lg-6 col-xl-3 align-self-center">
        <div class="input-material">
          <div class="add-datepicker">
            <button
              class="btn-clearDate"
              v-if="from_date"
              v-on:click="from_date = ''"
            >
              ✖
            </button>
            <Datepicker
              v-model="from_date"
              ref="from_date"
              typeable
            ></Datepicker>
            <label :class="from_date ? 'active' : ''">{{
              $t("fromdate")
            }}</label>
          </div>
        </div>
      </div>
      <!-- TO DATE -->
      <div class="col-lg-6 col-xl-3 align-self-center">
        <div class="input-material">
          <div class="add-datepicker">
            <button
              class="btn-clearDate"
              v-if="to_date"
              v-on:click="to_date = ''"
            >
              ✖
            </button>
            <Datepicker v-model="to_date" ref="to_date" typeable></Datepicker>
            <label :class="to_date ? 'active' : ''">{{ $t("todate") }}</label>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              id="issuer"
              name="issuer"
              v-validate="'required'"
              v-model="issuer_filter"
              placeholder="Card Issuer"
            />
            <label>{{ $t("issuer") }}</label>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-xl-2 align-self-center">
        <button @click.prevent.stop="Onfetch()" class="btn btn-blue w-100 px-2">
          {{ $t("apply_filter") }}
        </button>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="table-scroll">
      <table class="list-view-table cash_card_table mb-3">
        <thead>
          <tr>
          <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>

            <th>
              <span class="pl-2">
                <img
                  v-if="this.columnName != 'cash_card_number'"
                  @click="onSortValue('cash_card_number', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('cash_card_number', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('cash_card_number', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $tc("card") }} {{ $tc("number") }}
              </span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("customer") }} {{ $tc("name") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'cash_card_issuer'"
                @click="onSortValue('cash_card_issuer', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('cash_card_issuer', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('cash_card_issuer', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("issuer") }}
            </th>
            <th>{{ $t("card_generate_on") }}</th>
            <th>
              {{ $t("balance") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'last_transaction_at'"
                @click="onSortValue('last_transaction_at', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('last_transaction_at', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('last_transaction_at', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("last_transaction") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'mc.created_at'"
                @click="onSortValue('mc.created_at', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('mc.created_at', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('mc.created_at', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("card_generate_at") }}
            </th>
            
          </tr>
        </thead>
        <tbody v-if="cash_cards && cash_cards.length > 0">
          <tr v-for="(card, cardKey) in cash_cards" :key="cardKey"
          class="light_grey_back"
          >
          <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    card.cash_card_is_active === 'Y'
                      ? 'active'
                      : card.cash_card_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-2">
                  <b-dropdown-item
                    :to="{
                      name: 'Edit Cash Card',
                      params: { cash_card_id: card.cash_card_id },
                    }"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("update") }}
                  </b-dropdown-item>
                </b-dropdown>
                
              </div>
            </td>
            <td class="">
              <div class="d-flex align-items-center">
                <span
                  class="ml-2 fw-ms"
                  @dblclick="doCopy(card.cash_card_visible)"
                  >{{ card.cash_card_visible }}</span
                >
              </div>
            </td>
            <td>{{ getCardName(card) }}</td>
            <td>{{ card.cash_card_issuer || "-" }}</td>
            <td>
              {{ card.is_website_card == "Y" ? "Online Sale" : "POS Sale" }}
            </td>
            <td class="text-right">{{ currFormat(card.balance_amount) }}</td>
            <td class="text-right">{{ card.last_transaction_at | dateParseYYYYMMDD }}</td>
            <td class="text-right">{{ card.created_at | dateParseYYYYMMDD }}</td>
            
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="cash_cards.length > 0"
      class="d-flex justify-content-end mb-2 mx-3 align-items-center"
    >
      <div class="mr-2">{{ $t("export") }}:</div>
      <a
        :href="BASE_URL + `/api/admin/export_cash_cards${queryString}`"
        target="_blank"
        title="Download as Excel"
        download
      >
        <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
      </a>
    </div>
    <br />
    <b-pagination
      v-if="cash_cards.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
    ></b-pagination>
  </div>
</template>
<script>
import MarketingService from "@/services/MarketingService";
import { createQueryString } from "@/services/ApiHelper";
import MasterService from "@/services/MasterService";
import moment from "moment";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  computed: {
    queryString() {
      let queryString = ``;
      let obj = {
        filter_is_active: this.filter_is_active,
        from_date: this.from_date
          ? moment(this.from_date).format("YYYY-MM-DD")
          : "",
        to_date: this.to_date ? moment(this.to_date).format("YYYY-MM-DD") : "",
        issuer_filter: this.issuer_filter,
      };
      queryString = this.createQueryString(obj);
      return queryString;
    },
  },
  data() {
    return {
      is_website_card: null,
      cardType: "All",
      cardTypeArray: [
        {
          id: 1,
          value: null,
          name: "All",
        },
        {
          id: 2,
          value: "Y",
          name: "Website Card",
        },
        {
          id: 3,
          value: "N",
          name: "Dashboard Card",
        },
      ],
      reportUrl: "/api/admin/export_cash_cards",
      cash_cards: [],
      from_date: "",
      to_date: "",
      issuer_filter: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: 10,
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      filter_is_active: "Y",
    };
  },
  mounted() {
    this.getCashCardList();
    // this.getviewingnumber();
  },
  methods: {
    //Sort
    createQueryString,
    onChangeCardFilter(filter) {
      this.currentPage = 1;
      this.is_website_card = filter.value;
      this.cardType = filter.name;
      this.getCashCardList();
    },
    doCopy: function (cardNumber) {
      this.$copyText(cardNumber).then((e) => {
        if (e.action == "copy") {
          this.$toasted.show("Copied to Clipboard");
        }
      });
    },
    Onfetch() {
      if (this.from_date && !this.to_date) {
        return this.$toasted.show("Please Select To Date");
      } else if (!this.from_date && this.to_date) {
        return this.$toasted.show("Please Select From Date");
      } else if (
        moment(this.from_date).format("YYYY-MM-DD") >
        moment(this.to_date).format("YYYY-MM-DD")
      ) {
        return this.$toasted.show("To date must be greater than from date");
      } else {
        this.getCashCardList();
      }
    },
    getCardName(card) {
      let name = ``;
      if (card.customer_id || card.is_guest_user == "Y") {
        name = `${card.first_name} ${card.last_name ? card.last_name : ""}`;
      } else if (card.is_street_sale == "Y") {
        name = `Street Sale`;
      } else {
        name = "-";
      }
      return name;
    },
    onSearchCashCard() {
      this.currentPage = 1;
      this.getCashCardList();
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCashCardList();
    },
    onSearchCashCard() {
      this.currentPage = 1;
      this.getCashCardList();
    },
    getCashCardList: function () {
      let loader = this.$loading.show();

      let payload = {
        perPage: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        from_date: this.from_date
          ? moment(this.from_date).format("YYYY-MM-DD")
          : "",
        to_date: this.to_date ? moment(this.to_date).format("YYYY-MM-DD") : "",
        issuer_filter: this.issuer_filter,
        is_website_card: this.is_website_card,
        filter_is_active: this.filter_is_active,
      };

      MarketingService.GetCashCardList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.data.length > 0) {
            this.cash_cards = data.Records.data;
            if (data.Records.pagination.total) {
              this.rows = data.Records.pagination.total;
            }
            this.selectedvalue =
              data.Records.pagination.to - data.Records.pagination.from;
          } else {
            this.cash_cards = [];
            this.selectedvalue = 0;
            this.rows = 0;
            this.$toasted.show(this.$t("No Records Found"));
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally(() => setTimeout(() => loader.hide(), 1000));
    },
    onChangePagination: function (event) {
      console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
      } else {
        this.currentPage = event;
      }
      this.getCashCardList();
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = this.rows;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
  },
};
</script>
<style scoped>
.ls-1 {
  letter-spacing: 1px;
}

.fw-ms {
  font-family: Arial !important;
  color: #7a7c7e !important;
}
.cash_card_table td {
  padding: 0px 10px !important;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardComponents/cashCards.vue